<template>
<div style="padding-top: 15px;">
  <!--div class="col-sm-12 form-group">
    <div class="pull-right">
      <el-button type="primary"
        @click="publishEvent"
      >Publish Changes</el-button>
    </div>
  </div-->
  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div class="col-sm-12">
        <div class="ibox float-e-margins">
          <div class="ibox-content">
            <div class="row table-responsive" style="padding-bottom:60px;margin:0 !important;">
              <div class="col-sm-12 form-group">
                  <div class="Bold" style="font-size:16px;padding:15px 0;">Welcome to JPC App CMS!</div>
              </div>
              <div class="col-sm-6 homeBox">
                <label class="col-sm-4 control-label Bold">
                  Last publisher
                </label>
                <div class="col-sm-8">
                  {{lastPublisher}}
                </div>
              </div>
              <div class="col-sm-6 homeBox">
                <label class="col-sm-4 control-label Bold">
                  Last publish Date
                </label>
                <div class="col-sm-8">
                  {{lastPublishDate}}
                </div>
              </div>
              <div class="col-sm-12 homeBox">
                <label class="col-sm-2 control-label Bold">
                  Notes
                </label>
                <div class="col-sm-10">
                  This page is used for preview the action log before publish. Once publish, the past record will all be cleaned up.
                </div>
              </div>
              <div class="hr-line-dashed"></div>
              <div class="col-xs-12 form-group" style="padding-top: 30px;display: inline-block;">
              <h3 class="Bold">Action Log before Publish: </h3>
              </div>
              <el-table
                :data="rows"
                border
                style="width: 100%"
                ref="multipleTable"
                @selection-change="handleSelectionChange"
                row-key="id"
              >
                <el-table-column
                  prop="accessName"
                  :show-overflow-tooltip="true"
                  label="Section Name"
                  width="220"
                ></el-table-column>
                <el-table-column
                  prop="accessType"
                  :show-overflow-tooltip="true"
                  label="Change type"
                  width="150"
                ></el-table-column>
                <el-table-column
                  :show-overflow-tooltip="true"
                  prop="newVersionFileds"
                  label="New content"
                  width="240"
                ></el-table-column>
                <el-table-column
                  :show-overflow-tooltip="true"
                  prop="oldVersionFileds"
                  label="Old content"
                  width="240"
                ></el-table-column>
                <el-table-column
                  prop="createdAt"
                  label="Created at"
                  width="150"
                >
                </el-table-column>
                <el-table-column
                  prop="createdBy"
                  label="Created by"
                  width="150"
                >
                </el-table-column>
              </el-table>
              <el-col :span="24" class="el-table_footertoolbar">
                <el-pagination 
                   layout="total, sizes, prev, pager, next, jumper" 
                   @size-change="handleSizeChange" 
                   @current-change="handleCurrentChange" 
                   :page-sizes="[10, 20, 50, 100]" 
                   :page-size="pagesize" 
                   :total="total" 
                   style="float:right;">
                </el-pagination>
              </el-col>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import eventBus from "../eventbus";
import config from "../config";
import draggable from 'vuedraggable'

export default {
  mixins: [config.globalMixin],
  data() {
    return {
      page: 0,//当前页数
      pagesize:10,//一页显示几条
      total:0,
      rows:[],
      startDate:"",
      endDate:"",
      ocTable:"",
      ocAction:"",
      multipleSelection:[],
      sortType:"DESC",
      sortField:"id",
      showDetail:false,
      compareDetail:[],
      lastPublishDate:"",
      lastPublisher:""

    };
  },
  created() {

  },
  components: {
    draggable,
  }, 
  methods: {
    async publishEvent(){
      var objdata = this.getAuthObj();
      objdata.apiUrl = this.apiConfig.publishApi;
      let data = await this.$store.dispatch("apiEvent", objdata);
      if(data == "000104"){
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      this.$message({
        message: 'Publish Success',
        type: 'success'
      });
      this.page = 0;
      this.init()
    },
    async init() {
      var objdata = this.getAuthObj();
      objdata.page = {
        pageIndex: this.page,
        pageCount: this.pagesize,
      }
      objdata.sort = {
        name: this.sortField,
        type: this.sortType,
      }
      objdata.name = this.name;
      objdata.apiUrl = this.apiConfig.accessLogList;
      let data = await this.$store.dispatch("apiEvent", objdata);
      if(data == "000104"){
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      this.rows = data.data.result.accessLogs;
      this.lastPublisher = data.data.result.lastPublisher;
      this.lastPublishDate = this.dateFormat(data.data.result.lastPublishDate);
      this.total = data.data.result.total;
      let list = null;
      for (list of this.rows) {
        list.createdAt = this.dateFormat(list.createdAt)
      }
    },
  },
  mounted() {
    this.init();
  }
};
</script>
